import produce from 'immer';
import { JobState } from '../../types/state';
import { JOBS_ACTIONS } from '../actions/jobs';

const initialState: JobState = {
  jobs: undefined,
  loading: undefined,
  logsLoading: undefined,
  logs: undefined,
};

const jobReducer = (state = initialState, action) => {
  switch (action.type) {
    case JOBS_ACTIONS.JOBS_LOADING: {
      return produce(state, (draft) => {
        draft.loading = action.payload;
      });
    }
    case JOBS_ACTIONS.SET_JOBS:
      return produce(state, (draft) => {
        draft.jobs = action.payload;
      });
    case JOBS_ACTIONS.LOGS_LOADING:
      return produce(state, (draft) => {
        draft.logsLoading = action.payload;
      });
    case JOBS_ACTIONS.SET_LOGS:
      return produce(state, (draft) => {
        if (!draft.logs) draft.logs = {};
        const { clientId, date, data } = action.payload;
        if (!draft.logs[date]) draft.logs[date] = {};
        if (!clientId) {
          draft.logs[date]['all'] = data;
          data.forEach((log) => {
            if (!draft.logs[date][log.ClientId])
              draft.logs[date][log.ClientId] = [];
            draft.logs[date][log.ClientId].push(log);
          });
        } else draft.logs[date][clientId] = data;
      });
    default:
      return state;
  }
};

export default jobReducer;
